"use client";

import { useState, useEffect } from "react";

// Set the localStorage flag synchronously at module load (client-only)
// This ensures the flag is available before any useEffect runs
if (typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search);
  if (params.get("app") === "1") {
    localStorage.setItem("fulkit_app", "1");
  }
}

/**
 * useAppContext — detects whether the user is inside the native iOS/Android app.
 * Starts as false (matches server render), updates on mount (avoids hydration mismatch).
 */
export function useAppContext() {
  const [isApp, setIsApp] = useState(false);

  useEffect(() => {
    setIsApp(
      localStorage.getItem("fulkit_app") === "1" ||
      localStorage.getItem("fulkit-sim-ios") === "1"
    );
  }, []);

  return isApp;
}
